import isPropValid from '@emotion/is-prop-valid';
import { Clear } from '@ori-ui/icons';
import { Divider, List, ListItemButton, ListItemText, Modal, SHADOW_LEVEL2, styled } from '@ori-ui/mui';

export const Root = styled(Modal)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  overflow: 'hidden',

  [theme.breakpoints.down('sm')]: {
    alignItems: 'end',
  },
}));

export const Content = styled('div')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: SHADOW_LEVEL2,
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '472px',
  padding: theme.spacing(2),
  width: '472px',
  zIndex: 1,

  [theme.breakpoints.down('sm')]: {
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '0px',
    maxWidth: 'unset',
    width: '100%',
  },
}));

export const Header = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',
});

export const ClearIcon = styled(Clear)(({ theme }) => ({
  color: theme.palette.grey[700],
  cursor: 'pointer',
  height: '26px',
  width: '26px',
}));

export const StyledList = styled(List)({
  paddingBottom: '0px',
  width: 'calc(100% - 20px)',
});

export const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  color: theme.palette.grey[900],
  letterSpacing: '-0.2px',
  ...theme.typography.button,
  textTransform: 'none',
}));

export const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  height: '70px',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
}));

export const StyledDivider = styled(Divider, {
  shouldForwardProp: (propName: string) => isPropValid(propName),
})<{ isItemHovered: boolean }>(({ isItemHovered, theme }) => ({
  border: `1px solid ${theme.palette.grey[100]}`,
  height: '0px',
  ...(isItemHovered
    ? null
    : {
        marginLeft: '10px',
        marginRight: '10px',
      }),
}));
